<template>
  <b-row>
    <b-col lg="3">

      <div v-if="screenWidth">

        <div class="sidebar-box mt-6 p-1">
          <h6 class="mb-3 p-2" v-b-toggle.product-feature-filter>
            جدول
            <b-icon icon="arrow-down-circle"></b-icon>
          </h6>

          <b-collapse id="product-feature-filter" class="p-2">
            <div class="form-group form-check" v-for="field in fields">
              <input v-model="selectedProductFeature" :value="field" name="filter_product_features"
                     type="checkbox"
                     class="form-check-input" :id="`product-feature_filter_${field}`">
              <label class="form-check-label mr-3" :for="`product-feature_filter_${field}`">{{ field }}</label>
            </div>
          </b-collapse>


        </div>

        <m-features-1 @features="setProductFeature"/>
        <m-brands-301 @brand="setProductBrand"/>

      </div>

      <div v-if="!screenWidth">
        <b-button class="my-5" v-b-toggle.filter-sidebar>
          <b-icon-gear-fill/>
          فیلترها
        </b-button>

        <b-sidebar id="filter-sidebar" shadow>
          <div class="sidebar-box mt-6 p-1">
            <h6 class="mb-3 p-2" v-b-toggle.product-feature-filter>
              جدول
              <b-icon icon="arrow-down-circle"></b-icon>
            </h6>

            <b-collapse id="product-feature-filter" class="p-2">
              <div class="form-group form-check" v-for="field in fields">
                <input v-model="selectedProductFeature" :value="field" name="filter_product_features"
                       type="checkbox"
                       class="form-check-input" :id="`product-feature_filter_${field}`">
                <label class="form-check-label mr-3" :for="`product-feature_filter_${field}`">{{ field }}</label>
              </div>
            </b-collapse>


          </div>
          <m-features-1 @features="setProductFeature"/>
          <m-brands-301 @brand="setProductBrand"/>
        </b-sidebar>
      </div>

    </b-col>
    <b-col lg="9">

      <b-col lg="12">
        <div class="bg-white shadow product-order py-3" align-v="center">
          <span class="mx-3 text-muted ">مرتب سازی بر اساس:</span>

          <label for="asc" class="mx-2 btn "
                 :class="{'text-white btn-primary':sort==='asc','text-dark btn-outline-primary':sort!=='asc'}">
            ارزان ترین
          </label>
          <input id="asc" name="price_order" value="asc" v-model="sort" type="radio" class="d-none">

          <label for="desc" class="mx-2 btn"
                 :class="{'text-white btn-primary':sort==='desc','text-dark btn-outline-primary':sort!=='desc'}">
            گران ترین
          </label>
          <input id="desc" name="price_order" value="desc" v-model="sort" type="radio" class="d-none">


          <label
              class="my-3 text-white border p-1 rounded rounded-9 border-1 text-dark btn-outline-primary my-auto mx-3"
              @click="productTableToExcel('product-305-table', 'name', productTableExcelName)"
          >
            خروجی excel
            <div class="d-inline">
              <svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <linearGradient id="a" x1="4.494" y1="-2092.086" x2="13.832" y2="-2075.914"
                                  gradientTransform="translate(0 2100)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#18884f"/>
                    <stop offset="0.5" stop-color="#117e43"/>
                    <stop offset="1" stop-color="#0b6631"/>
                  </linearGradient>
                </defs>
                <title>file_type_excel</title>
                <path
                    d="M19.581,15.35,8.512,13.4V27.809A1.192,1.192,0,0,0,9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5Z"
                    style="fill:#185c37"/>
                <path d="M19.581,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5L19.581,16l5.861,1.95L30,16V9.5Z"
                      style="fill:#21a366"/>
                <path d="M8.512,9.5H19.581V16H8.512Z" style="fill:#107c41"/>
                <path d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
                      style="opacity:0.10000000149011612;isolation:isolate"/>
                <path d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                      style="opacity:0.20000000298023224;isolation:isolate"/>
                <path d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                      style="opacity:0.20000000298023224;isolation:isolate"/>
                <path d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
                      style="opacity:0.20000000298023224;isolation:isolate"/>
                <path
                    d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
                    style="fill:url(#a)"/>
                <path
                    d="M5.7,19.873l2.511-3.884-2.3-3.862H7.758L9.013,14.6c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359,3.84,2.419,3.905H10.821l-1.45-2.711A2.355,2.355,0,0,1,9.2,16.8H9.176a1.688,1.688,0,0,1-.168.351L7.515,19.873Z"
                    style="fill:#fff"/>
                <path d="M28.806,3H19.581V9.5H30V4.191A1.192,1.192,0,0,0,28.806,3Z" style="fill:#33c481"/>
                <path d="M19.581,16H30v6.5H19.581Z" style="fill:#107c41"/>
              </svg>
            </div>
          </label>


        </div>

      </b-col>




      <m-products-wrapper per-page="500" @products="setFields" :product-brands="productBrand" :sort="sort"
                          :product-features="productFeature"
                          :product-categories="productCategory">
        <b-row slot-scope="{products,pagination,changePageFunction}">
          <div class="col-lg-12 mt-3 table-font-size">
            <table class="table table-responsive table-striped table-hover" id="product-305-table">
              <thead>
              <tr>
                <th>نام</th>
                <th v-for="field in fields" v-if="showItem(field)">{{ field }}</th>
                <th>#</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="product in products">
                <th>{{ product.name }}</th>
                <th scope="row" v-for="item in productFeatures(product.features)" v-if="showItem(item.text)">
                  {{ item.text }} - {{ item.value }}
                </th>
                <th class="products305-price-th">
                  <m-product-price-100 :product="product"/>
                  <span v-if="product.price == null">{{ findAttributeOnSiteInfo('setNullPrice')[0] }}</span>
                  <!--                  <m-shopping-cart-controller-1 class="product-shopping-cart" :product="product"/>-->
                </th>
              </tr>
              </tbody>
            </table>
          </div>

          <b-col lg="12" v-if="paginate">
            <m-pagination-400 class="mx-auto my-2" :meta="pagination" :on-change-page="changePageFunction"/>
          </b-col>

        </b-row>

      </m-products-wrapper>
    </b-col>
  </b-row>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter.js";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "Products304",
  props: {
    paginate: {
      default: false
    }
  },
  data() {
    return {
      productCategory: null,
      productFeature: null,
      sort: '',
      productBrand: null,
      fields: [],
      selectedProductFeature: [],
    }
  },
  methods: {
    setProductCategory(category) {
      this.productCategory = [category]
    },
    setProductFeature(feature) {
      this.productFeature = feature.length > 0 ? feature : null
    },
    setProductBrand(brand) {
      this.productBrand = brand.length > 0 ? brand : null
    },
    productFeatures(product_features) {
      let product_variation = [];


      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product

        if (feature.feature_values.sub_product == 0 && feature.feature_values.variation == 0) {
          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          if (feature.type == 'text') {
            product_variation.push({text: feature.name, value: feature.feature_values.feature_value})
          }

          if (feature.type == 'list') {
            feature_attributes.forEach(item => {
              if (item.id == feature_attribute_id) {
                product_variation.push({...item, text: feature.name, value: item.value})
              }
            })

          }


        }

      }

      return product_variation
    },
    setFields(products) {

      products.forEach(product => {
        let product_features = this.productFeatures(product.features);
        product_features.forEach(item => {
          if (this.fields.indexOf(item.text) === -1) {
            this.fields.push(item.text)
          }
        })
      })

    },
    showItem(item) {

      if (this.selectedProductFeature.length == 0) {
        return true
      }
      if (this.selectedProductFeature.indexOf(item) > -1) {
        return true
      }

      return false


    },
    productTableToExcel(table, name, filename) {
      let uri = 'data:application/vnd.ms-excel;base64,',
          template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><title></title><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
          base64 = function (s) {
            return window.btoa(decodeURIComponent(encodeURIComponent(s)))
          }, format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
              return c[p];
            })
          }

      if (!table.nodeType) table = document.getElementById(table)
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}

      var link = document.createElement('a');
      link.download = filename;
      link.href = uri + btoa(unescape(encodeURIComponent(format(template, ctx))))
      link.click();
    },
    dateConverter,
  },
  computed: {
    screenWidth() {
      return window.outerWidth >= 1000
    },
    productTableExcelName() {
      let today = new Date();
      const todayJalali = this.dateConverter(today, '_')
      return `لیست قیمت ${todayJalali} - ${findAttributeOnSiteInfo('site_name')[0]}.xls`
    }
  },
  mounted() {
    const routeCategory = this.$route.query.category
    if (routeCategory !== undefined) {
      this.productCategory = [routeCategory]
    }

    const routeBrand = this.$route.query.brand
    if (routeBrand !== undefined) {
      this.productBrand = [routeBrand]
    }
  }
}
</script>


<style>
.products305-price-th .product-shopping-cart .btn-primary {
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  color: var(--dark) !important;
  border: none;
}
</style>

<style scoped>
.product-order {
  border-radius: 10px;
}

.table-font-size {
  font-size: 12px;
}

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}


</style>